module.exports = {
  title: 'ERP原始数据',
  route: {
    path: '/seller-goods-manage',
    children: {
      path: 'erp-original-data',
    },
  },
};
